// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1g-0";
export var spinnerContainer = "_1g-1";